import {call, put, takeEvery, takeLatest} from 'redux-saga/effects'
import * as actions from "./../user/actions";
import UserApi from "./UserApi";
import * as errorActions from "../error/actions";


export function* setUser() {
  try {
    const resp = yield call(UserApi.getUserDetails);

    if (resp.data && resp.data != null) {
      yield put(actions.Generator.setUser(resp.data));
    }
    else {
      yield put(actions.Generator.removeUser());
    }
  }
  catch (e) {
    yield put(errorActions.Saga.setError(e));
  }
}


function* userSaga() {
  yield takeLatest(actions.SAGA_SET_USER, setUser);
}

export default userSaga;